import React from 'react';
import { BoxFormAutocomplete } from 'src/components/profileComponents/FormAutocomplete';
import { translations } from 'src/constants/translations';
import {
  IDevelopmentSpecificationPropChange,
} from 'src/components/profileComponents/Complexes/components/ProjectSpecification/types';
import { UnitTilePropertyType } from 'src/components/profileComponents/Marketplace/components/UnitsTiles/constants';
import { fontWeightOptions, Option, textDecorationOptions } from 'src/components/profileComponents/Marketplace/types';
import Box from '@mui/material/Box';
import { IMarketplaceStyles, IMarketplaceStylesType } from 'src/typings/marketplaceTile';
import { ColorPicker } from 'src/components/profileComponents/ColorPicker';

export const UnitStyle: React.FC<{
  entityConfig: string[],
  entityStyles: IMarketplaceStylesType,
  updateProperty: (property: keyof IMarketplaceStyles, value: string) => void
}> = ({ entityConfig, entityStyles, updateProperty }) => {
  const findFortWeightByValue = (value: number | string | undefined): Option<string> | undefined => {
    return fontWeightOptions.find((item) => item?.value === String(value));
  };

  return (
    <>
      { entityStyles && (
      <Box display="flex" gap="20px">
        {entityConfig.includes('fontWeight') && (
          <BoxFormAutocomplete
            label={translations.fontWeight}
            name="weight"
            defaultValue={findFortWeightByValue(entityStyles?.fontWeight)}
            onChange={(event: IDevelopmentSpecificationPropChange<UnitTilePropertyType>) => {
              updateProperty('fontWeight', event.value);
            }}
            options={fontWeightOptions}
          />
        ) }
        {entityConfig.includes('fontDecoration') && (
          <BoxFormAutocomplete
            label={translations.fontDecoration}
            name="decoration"
            defaultValue={{ label: entityStyles?.textDecoration, value: entityStyles?.textDecoration }}
            onChange={(event: IDevelopmentSpecificationPropChange<UnitTilePropertyType>) => {
              updateProperty('textDecoration', event.value);
            }}
            options={textDecorationOptions}
          />
        ) }
        {entityConfig.includes('fontColor') && (
          <Box mb={6} display="flex" flexDirection="column" width="100%" gap="10px">
            {translations.fontColor}
            <ColorPicker
              color={entityStyles.color}
              colorSetter={(changeColor) => updateProperty('color', changeColor)}
            />
          </Box>
        ) }
        {entityConfig.includes('backgroundColor') && (
          <Box mb={6} display="flex" flexDirection="column" width="100%" gap="10px">
            {translations.backgroundColor}
            <ColorPicker
              color={entityStyles.backgroundColor}
              colorSetter={(changeColor) => updateProperty('backgroundColor', changeColor)}
            />
          </Box>
        ) }
        {entityConfig.includes('outlineColor') && (
          <Box mb={6} display="flex" flexDirection="column" width="100%" gap="10px">
            {translations.outlineColor}
            <ColorPicker
              color={entityStyles.borderColor}
              colorSetter={(changeColor) => updateProperty('borderColor', changeColor)}
            />
          </Box>
        ) }
      </Box>
      )}
    </>
  );
};
